import { ApiError } from '@gorila-shared-ui/components';
import {
  confirmResetPassword,
  getCurrentUser,
  resetPassword,
  ResetPasswordOutput,
  signIn,
  signOut,
} from 'aws-amplify/auth';

export const authSignIn = async (username: string, password: string): Promise<{ user?: any; error?: ApiError }> => {
  try {
    const user = await signIn({ username, password });
    return { user };
  } catch (error: any) {
    if (error?.message === 'Unable to login because of security reasons.') {
      return {
        error: 'Usuario bloqueado, intenté más tarde.',
      };
    }
    return {
      error: 'Credenciales incorrectas.',
    };
  }
};

export const autoLogin = async (): Promise<{ user?: any; error?: ApiError }> => {
  try {
    const authUser = await getCurrentUser();
    return { user: authUser };
  } catch (err) {
    return { error: 'Not authenticated' };
  }
};

export const authSignOut = async (): Promise<void> => {
  await signOut();
};

export const sendForgottenCode = async (
  username: string
): Promise<{ user?: ResetPasswordOutput; error?: ApiError }> => {
  try {
    const user = await resetPassword({ username });
    return { user };
  } catch (error) {
    return { error: 'El usuario no existe' };
  }
};

export const forgotPasswordSubmit = async (
  username: string,
  confirmationCode: string,
  newPassword: string
): Promise<{ user?: any; error?: ApiError }> => {
  try {
    const user = await confirmResetPassword({ username, confirmationCode, newPassword });
    return { user };
  } catch (error) {
    return { error: 'Error, intentelo mas tarde o pongase en contacto con atencion a clientes' };
  }
};
